import React from 'react';
import EmergencyDatabaseDebug from '../components/EmergencyDatabaseDebug';

const EmergencyDebug = () => {
  return (
    <div className="min-h-screen bg-red-50 py-8">
      <EmergencyDatabaseDebug />
    </div>
  );
};

export default EmergencyDebug;